import { formatDistanceToNow } from "date-fns";
import { zonedTimeToUtc, utcToZonedTime, format } from 'date-fns-tz';

const Filters = {
  humanDate(timestamp) {
   	if (typeof timestamp !== "undefined") {
      let date = new Date(timestamp);
      return formatDistanceToNow(date, { addSuffix: true });
    }
  },
  ukDate(timestamp) {
   	if (typeof timestamp !== "undefined") {
      let date = new Date(timestamp);
      return format(date, 'do MMMM yyyy');
    }
  },
  ukDateShort(timestamp) {
    if (typeof timestamp !== "undefined") {
      let date = new Date(timestamp);
      return format(date, 'do MMM Y');
    }
  },
  ukDateTime(timestamp) {
    if (typeof timestamp !== "undefined") {
      let date = new Date(timestamp);
			const timeZone = 'Europe/London';
			const pattern = 'do MMM Y - HH:mm (z)';
			let zonedDate = utcToZonedTime(date,timeZone);
      return format(zonedDate, pattern, { 'timeZone': timeZone });
    }
  },
  convertWords(str, replaceWordsArr) {
    // Convert words in str if they are in the replaceWordsArr.
    if(str) {
      let convertedStr = str;
      replaceWordsArr.forEach(obj => {
        convertedStr = convertedStr.replaceAll(obj.from, obj.to);
      });
      return convertedStr;
    }
  },
  capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  },
  toFixed(num, fixed = 2) {
    if(num) {
      let re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
      return num.toString().match(re)[0];
    }
  },
  convertResourceType(slug) {
    slug = slug.toLowerCase();
    switch (slug) {
      case 'course':
        slug = 'course-content'
        break;
      case 'escape story':
        slug = 'story';
        break;
      case 'templates':
        slug = 'template'
        break;
    }
    return slug;
  },
	analyseImage(url,x1,x2) {
		// Sizes here: https://trello.com/c/F6dxNXzC
		if (url.includes("https://imagedelivery.net/UyWgzBGGhtJ_birCaenX3A") && x1 && x2) {
			let parts = url.split("/");
			let ending = parts.pop();
			if (ending == "public") {
				if (window.devicePixelRatio == 1) {
					parts.push(x1);
				} else {
					parts.push(x2);
				}
				url = parts.join("/");
			}
		}
		return url;
	},
	pluralize(word, amount) {
		return (amount > 1 || amount === 0) ? `${word}s` : word;
	},
	truncateString(string,maxLength) {
		if (string.length > maxLength) {
			//trim the string to the maximum length
			var trimmedString = string.substr(0, maxLength);
			//re-trim if we are in the middle of a word
			trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
			return trimmedString + '...';
		}
		return string;
	},
	getUrlPathSegments() {
		return new URL(window.location.href).pathname.split('/').filter(Boolean);
	}
}

export default Filters;
